import React from 'react'

const IconLink = ({ fill = '#095BBD' }) => {
  return (
    <svg width='16' height='8' viewBox='0 0 16 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.67828 7.2312H4.06286C3.16898 7.2312 2.40703 6.91578 1.77703 6.28495C1.14703 5.65425 0.832031 4.89148 0.832031 3.99662C0.832031 3.10162 1.14703 2.34002 1.77703 1.71182C2.40703 1.08363 3.16898 0.769531 4.06286 0.769531H6.67828V1.4362H4.06286C3.35773 1.4362 2.75405 1.68731 2.25182 2.18953C1.74974 2.69162 1.4987 3.29523 1.4987 4.00037C1.4987 4.7055 1.74974 5.30912 2.25182 5.8112C2.75405 6.31342 3.35773 6.56453 4.06286 6.56453H6.67828V7.2312ZM5.41536 4.3337V3.66703H10.582V4.3337H5.41536ZM9.31911 7.2312V6.56453H11.9345C12.6397 6.56453 13.2434 6.31342 13.7456 5.8112C14.2477 5.30912 14.4987 4.7055 14.4987 4.00037C14.4987 3.29523 14.2477 2.69162 13.7456 2.18953C13.2434 1.68731 12.6397 1.4362 11.9345 1.4362H9.31911V0.769531H11.9345C12.8284 0.769531 13.5904 1.08495 14.2204 1.71578C14.8504 2.34648 15.1654 3.10925 15.1654 4.00411C15.1654 4.89911 14.8504 5.66071 14.2204 6.28891C13.5904 6.9171 12.8284 7.2312 11.9345 7.2312H9.31911Z'
        fill={fill}
      />
    </svg>
  )
}

export default IconLink
